/*
 * https://yhashimoto.com
 * Copyright Yohei Hashimoto */
 
import $ from 'jquery';
import { VarUtil } from '../../utils/var-util.js';
import { RouterUtil } from '../../utils/router.js';
import { NumberUtil } from '../../utils/number.js';

document.addEventListener('DOMContentLoaded', () => {

    const $list = document.getElementById("list-filter");
    const $btns = document.querySelectorAll('[data-filter]:not([data-filter="all"])');
    const $btnAll = document.querySelectorAll('[data-filter="all"]');
    const $filterItems = document.querySelectorAll(".filter-i");
    const $filteredTagsLabel = document.querySelector(".filtered-tags-label");
    const $filteredTagsCount = document.querySelector(".filtered-tags-count");

    // Props ////////////////////////////////////////////////////////

    // 検索モード
    // single : 1つのワードごとに検索
    // and : 絞り込み
    // or : or検索
    let mode = $list.dataset.mode ? $list.dataset.mode : 'single';
    let filteredTagsSeparator = mode === 'and' ? '+' : ', ';

    // フィルタしている条件 Array
    let filteredSlugs = getFilteredSlag();

    // すべての検索条件 label & slug
    let filters = [];

    // List item length
    let filteredItemLength = $filterItems.length;

    // 一時的変数
    let filterVal = '';
    let resizeTimeout;

    const listFilterCSSVars = window.getComputedStyle($list);
    const leaveDur = parseInt(NumberUtil.convertToMilliseconds(listFilterCSSVars.getPropertyValue('--leave-dur')));
    const moveDur = parseInt(NumberUtil.convertToMilliseconds(listFilterCSSVars.getPropertyValue('--move-dur')));
    const enterDur = parseInt(NumberUtil.convertToMilliseconds(listFilterCSSVars.getPropertyValue('--enter-dur')));
    
    console.log(moveDur);
    
    // On Mounted ////////////////////////////////////////////////////////

    // Init Btns
    $btns.forEach(btn => {

        const filterVal = btn.dataset.filter;

        btn.addEventListener('click', () => {
            transition();
            setTimeout(function() {
                filteredSlugs = setFilters(filterVal);
                filterItems();
                setStyles();
                RouterUtil.setQueryParameters('slugs', filteredSlugs)
            }, leaveDur + 20);

        });

        // filtersに格納
        filters.push({
            label: btn.textContent,
            slug: filterVal
        });

        //console.log(filters);
    });

    $btnAll.forEach(btn => {
        // Init Btn for All
        btn.addEventListener('click', () => {
            transition();
            setTimeout(function() {
                filteredSlugs = ['all'];
                filterItems();
                setStyles();
                RouterUtil.setQueryParameters('', '')
            }, leaveDur + 20);
        });
    
        filters.push({
            label: btn.textContent,
            slug: 'all'
        });
    });

    // window.addEventListener('resize', resizeWindow);
    // transition();
    setTimeout(function() {
        resizeWindow();
        filterItems();
        setStyles();
    }, 5);

    // No itemのちらつき防止のために読み完了後に -readyをいれる
    setTimeout(function() {
        $list.classList.add('-ready');
    }, 10);


    // Methods ////////////////////////////////////////////////////////

    function getFilteredSlag() {

        if (RouterUtil.getQueryParamToArray('slugs').length === 0) {

            // Has default slug
            if ($list.dataset.default) {
                return [$list.dataset.default];
            } else {
                return ['all'];
            }
        } else {
            return RouterUtil.getQueryParamToArray('slugs');
        }

    }

    function filterItems() {

        filteredItemLength = 0;

        // List items
        $filterItems.forEach(i => {

            if (filteredSlugs.every(item => item === 'all')) {
                i.classList.remove('-hidden');
                filteredItemLength = $filterItems.length;

            } else {

                // Init
                i.classList.remove('-hidden');
                let isHave = true;

                // Slugs of Item
                const slugs = i.dataset.slugs.split(',');


                if (mode === 'and') {
                    isHave = filteredSlugs.every(val => slugs.includes(val));

                } else {
                    isHave = filteredSlugs.some(value => slugs.includes(value));
                }

                if (isHave) {
                    // Display
                    //console.log(filteredItemLength);
                    ++filteredItemLength;

                } else {
                    // Hide
                    i.classList.add('-hidden');

                }
            }
            
            $('.-js-filtered-length').html(padNumber(filteredItemLength, 2));
        });

        // For Overlayscrollbars
        // 現在のブラウザの高さを取得
        const originalHeight = window.innerHeight;
        resizeWindow();

        //console.log(osInstance.update());

        // ブラウザの高さを1px増やす
        document.documentElement.style.height = (originalHeight - 1) + 'px';

        // 1ms 後にブラウザの高さを元に戻す
        // setTimeout(function() {
        //     osInstance.update();
        //     document.documentElement.style.height = originalHeight + 'px';
        // }, 1000);
    }


    function setFilters(filterVals) {

        if (!filteredSlugs) {
            filteredSlugs = ['all'];
        }

        if (filterVals) {

            // allが混ざっていた場合削除
            filteredSlugs = filteredSlugs.filter(item => item !== 'all');
            // Single Filter
            if (mode === 'and' || mode === 'or') {
                if (filterVals === 'all') {
                    filteredSlugs = ['all'];

                } else {
                    const index = filteredSlugs.indexOf(filterVals);

                    if (index !== -1) {
                        filteredSlugs.splice(index, 1); // 既存の値を取り除く
                    } else {
                        filteredSlugs.push(filterVals); // 新しい値を追加
                    }
                }

            } else {
                // Single
                if (filteredSlugs.includes(filterVals)) {
                    // filteredSlugsにfilterValsと同じ値が含まれている場合の処理
                    //console.log('filteredSlugsにfilterValsと同じ値が含まれています。');
                    filteredSlugs = ['all'];

                } else {
                    // filteredSlugsにfilterValsと同じ値が含まれていない場合の処理
                    //console.log('filteredSlugsにfilterValsと同じ値は含まれていません。');
                    filteredSlugs = [filterVals];
                }
            }

        } else {
            filteredSlugs = ['all'];
        }

        if (filteredSlugs.length == 0) {
            filteredSlugs = ['all'];
        }

        // テスト出力
        //console.log(filteredSlugs);
        return filteredSlugs;
    }

    function transition() {

        $list.classList.remove('-leave');
        $list.classList.remove('-move');
        $list.classList.remove('-enter');
        $list.classList.add('-leave');

        setTimeout(function() {
            $list.classList.remove('-leave');
            $list.classList.add('-move');

            setTimeout(function() {
                $list.classList.remove('-move');
                $list.classList.add('-enter');

                setTimeout(function() {
                    $list.classList.remove('-leave');
                    $list.classList.remove('-move');
                    $list.classList.remove('-enter');
                }, enterDur + 50);
            }, moveDur + 50);
        }, leaveDur + 50);
    }

    function setStyles() {

        //console.log($filterItems[0].offsetWidth);

        // Reset btn styles
        $btns.forEach(btn => {
            btn.dataset.filtered = '0';
        });

        // has Only All
        if (filteredSlugs.every(item => item === 'all')) {
            $btnAll.forEach(btn => {
                btn.dataset.filtered = '1';
            });

        } else {
            $btnAll.forEach(btn => {
                btn.dataset.filtered = '0';
            });

            // Style Active Buttons
            $btns.forEach(btn => {
                btn.dataset.filtered = filteredSlugs.includes(btn.dataset.filter) ? '1' : '0';
            });
        }

        if ($filteredTagsLabel) {

            // filteredSlugsの値をkeyにして、filtersから該当するlabelをカンマ区切りで取得
            let filteredLabels = filteredSlugs.map(slug => {
                let filter = filters.find(filter => filter.slug === slug);
                return filter ? filter.label : null;
            }).filter(label => label !== null).join(filteredTagsSeparator);

            $filteredTagsLabel.innerHTML = filteredLabels;
        }

        if ($filteredTagsCount) {

            if (filteredItemLength === $filterItems.length) {
                $filteredTagsCount.innerHTML = `(${filteredItemLength})`;
            } else {
                $filteredTagsCount.innerHTML = `(${filteredItemLength} of ${$filterItems.length})`;
            }
        }

        $list.dataset.filteredlength = filteredItemLength;


    }


    function resizeWindow() {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(function() {
//             $list.classList.remove('-leave');
//             $list.classList.remove('-move');
//             $list.classList.remove('-enter');
//
//             $list.classList.add('-leave');
//
//             setTimeout(function() {
//                 $list.classList.add('-move');
//
//                 setTimeout(function() {
//                     $list.classList.add('-enter');
//
//                     setTimeout(function() {
//                         $list.classList.remove('-leave');
//                         $list.classList.remove('-move');
//                         $list.classList.remove('-enter');
//                     }, enterDur + 20);
//                 }, moveDur + 20);
//             }, leaveDur + 20);


//             $filterItems.forEach(i => {
//
//                 i.style.width = '';
//                 i.style.height = '';
//
//                 setTimeout(function() {
//                     i.style.width = (i.clientWidth / 10) + 'rem';
//                     i.style.height = (i.clientHeight / 10) + 'rem';
//                 }, 1600);
//             });

        }, 200);
    }
    
    function padNumber(num, digits) {
        // 数値を文字列に変換し、必要な桁数になるように0で埋める
        return String(num).padStart(digits, '0');
    }

});
